import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\Picture\DeletePictureDossierController::__invoke
* @see app/Http/Controllers/Dossier/Picture/DeletePictureDossierController.php
* @route '/api/dossier/{dossier}/picture/{collection_name}'
*/
const DeletePictureDossierController = (args: { dossier: string | number | { id: string | number }, collection_name: string | number } | [dossier: string | number | { id: string | number }, collection_name: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeletePictureDossierController.url(args, options),
    method: 'delete',
})

DeletePictureDossierController.definition = {
    methods: ["delete"],
    url: '/api/dossier/{dossier}/picture/{collection_name}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Dossier\Picture\DeletePictureDossierController::__invoke
* @see app/Http/Controllers/Dossier/Picture/DeletePictureDossierController.php
* @route '/api/dossier/{dossier}/picture/{collection_name}'
*/
DeletePictureDossierController.url = (args: { dossier: string | number | { id: string | number }, collection_name: string | number } | [dossier: string | number | { id: string | number }, collection_name: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
            collection_name: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
        collection_name: args.collection_name,
    }

    return DeletePictureDossierController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace('{collection_name}', parsedArgs.collection_name.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Picture\DeletePictureDossierController::__invoke
* @see app/Http/Controllers/Dossier/Picture/DeletePictureDossierController.php
* @route '/api/dossier/{dossier}/picture/{collection_name}'
*/
DeletePictureDossierController.delete = (args: { dossier: string | number | { id: string | number }, collection_name: string | number } | [dossier: string | number | { id: string | number }, collection_name: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeletePictureDossierController.url(args, options),
    method: 'delete',
})

export default DeletePictureDossierController